import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { OpportunityStatusClient, OpportunityStatusView } from './api-proxies';
import { BaseDtoService } from './reporting-app/base-dto.service';

@Injectable({
    providedIn: 'root'
})
export class OpportunityStatusService extends BaseDtoService {
    constructor(private readonly client: OpportunityStatusClient) {
        super();
    }

    async getAll(): Promise<OpportunityStatusView[]> {
        return await lastValueFrom(this.client.opportunityStatusGetAll());
    }

    async getByIds(opportunityIds: number[]): Promise<OpportunityStatusView[]> {
        return await lastValueFrom(this.client.opportunityStatusGetByIds(opportunityIds));
    }

    async statusSearchManualStatus(isNew: boolean): Promise<OpportunityStatusView[]> {
        return await lastValueFrom(this.client.opportunityStatusSearchManualStatus(isNew));
    }

    async getAllForEstimate(): Promise<OpportunityStatusView[]> {
        return await lastValueFrom(this.client.opportunityStatusGetAllForEstimate());
    }

    async getNonQualifiedStatuses(): Promise<OpportunityStatusView[]> {
        return await lastValueFrom(this.client.opportunityStatusGetNonQualifiedStatuses());
    }
}
